module.exports = __webpack_public_path__ + "static/media/html.ae211695.png";